import axios from "axios";
import { IMAGE_UPLOAD_URL } from "./config";

export const uploadImageToCloudinary = async (image) => {
  try {
    if (!image || !image.type) {
      throw new Error("Invalid image object");
    }

    if (!image.type.startsWith("image/")) {
      throw new Error("Only image files are allowed");
    }

    const formData = new FormData();
    formData.append("image", image);

    const response = await axios.post(
      IMAGE_UPLOAD_URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          accept: "*/*",
        },
      }
    );
    console.log({ response });

    return response.data.imageUrl;
  } catch (error) {
    console.error("Image upload failed:", error.message);
    throw error;
  }
};
